export default function buildBusinessCasePayload(
  questionsData = {},
  inputs = {},
  geographyScope = {}
) {
  const toNum = v => (v === '' || v == null ? null : Number(v));
  const toPercent = v => (v === '' || v == null ? null : `${v}%`);
  const toStr = v => (v === '' || v == null ? null : String(v));

  return {
    brand_name: questionsData?.brand_name ?? null,
    product_type: questionsData?.product_type ?? [],
    sales_channels: questionsData?.sales_channels ?? null,
    markets: questionsData?.markets ?? [],
    recommended_geography_order: geographyScope?.recommendation_order ?? [],
    avg_rrp: toNum(inputs.rrp) ?? questionsData?.avg_rrp ?? null,
    offers_repairs:
      questionsData?.offers_repairs ??
      (inputs?.repairablePct > 0 ? 'Yes' : 'No'),
    facilities_type: questionsData?.facilities_type ?? null,
    monthly_aftersales_demand:
      toNum(inputs.customerMonthlyDemand) ??
      questionsData?.monthly_aftersales_demand ??
      null,
    stakeholders: questionsData?.stakeholders ?? null,
    business_goals: questionsData?.business_goals ?? [],

    repurchase_rate_general:
      toPercent(inputs.brandCurrentRepurchaseRate) ??
      questionsData?.repurchase_rate_general ??
      null,

    returns_volume_fit:
      toStr(inputs.monthlyVolumeForReturns) ??
      (questionsData?.returns_volume_fit != null
        ? String(questionsData.returns_volume_fit)
        : null),

    volumes_of_defective_items_warranty:
      toNum(inputs.defectiveClaims) ??
      questionsData?.volumes_of_defective_items_warranty ??
      null,

    annual_production:
      toNum(inputs.annualProductionVolumes) ??
      questionsData?.annual_production ??
      null,

    defect_percentage:
      toPercent(inputs.defectivePct) ??
      questionsData?.defect_percentage ??
      null,

    total_num_customers:
      toStr(inputs.totalNoOfCustomers) ??
      (questionsData?.total_num_customers != null
        ? String(questionsData.total_num_customers)
        : null),

    pct_customers_under_35:
      toPercent(inputs.customersUnder35Pct) ??
      questionsData?.pct_customers_under_35 ??
      null,

    purchase_rate_under_35:
      toPercent(inputs.repurchaseRateOfCustomersUnder35) ??
      questionsData?.purchase_rate_under_35 ??
      '10%',

    aftersales_process: questionsData?.aftersales_process ?? null,

    avg_cost_per_hr:
      toStr(inputs.avgCostPerEmployee) ??
      (questionsData?.avg_cost_per_hr != null
        ? String(questionsData.avg_cost_per_hr)
        : null)
  };
}
